export * from './data-transfer.interface';
export * from './data-transfer.service';
export * from './data-transfer.mock';
export const DATA_TRANSFER_SERVICE = Symbol('DataTransferService');
